import type { SupportedLocale } from '@brightdrop/localization-core';

/**
 * Each language named in itself, so a reader can find theirs whatever language
 * the page is currently in. These are deliberately not translation keys.
 */
export const LOCALE_OPTION_LABELS: Record<SupportedLocale, string> = {
  'en-US': 'English (USA)',
  'es-MX': 'Español (MEX)',
  'en-CA': 'English (CAN)',
  'fr-CA': 'Français (CAN)',
};

/** The order locales are listed in the language dropdown. */
export const LOCALE_OPTION_ORDER: readonly SupportedLocale[] = [
  'en-US',
  'es-MX',
  'en-CA',
  'fr-CA',
];
